import { capitalize } from "@mui/material";

export const getStatusDescription = (status: string) => {
  return status.split("_").map(word => capitalize(word)).join(" ");
};